import { render, staticRenderFns } from "./Paso2View.vue?vue&type=template&id=39b0bd18"
import script from "./Paso2View.vue?vue&type=script&lang=js"
export * from "./Paso2View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports